import React, { useState, useEffect } from "react";
import Container from "../components/container/container";
//images and icons
import Banner from "../assets/images/pictures/help-banner.jpg";
import BannerDark from "../assets/images/pictures/help-banner-dark.png";

export default function PrivacyPolicy() {
  const [isDarkMode, setIsDarkMode] = useState(false);
  useEffect(() => {
    if (document.documentElement.classList.contains("dark")) {
      setIsDarkMode(true);
    }
  }, []);

  return (
    <div>
      <div
        className="min-h-96 bg-cover no-repeat bg-center relative z-0"
        style={{
          backgroundImage: `url('${isDarkMode ? BannerDark : Banner}')`,
        }}
      >
        <Container>
          <div className="py-14">
            <div className="py-2 max-w-[1000px] px-6 mx-auto relative">
              <div className="absolute left-0 top-0 h-full border-l-4 border-primary"></div>

              {/* <!-- Right border --> */}
              <div className="absolute right-0 top-0 h-full border-r-4 border-primary"></div>

              {/* <!-- Top left --> */}
              <div className="absolute top-0 left-0 w-12 border-t-4 border-primary"></div>

              {/* <!-- Top right --> */}
              <div className="absolute top-0 right-0 w-12 border-t-4 border-primary"></div>

              {/* <!-- Bottom left --> */}
              <div className="absolute bottom-0 left-0 w-12 border-b-4 border-primary"></div>

              {/* <!-- Bottom right --> */}
              <div className="absolute bottom-0 right-0 w-12 border-b-4 border-primary"></div>
              <h2
                className="text-lg sm:text-2xl text-center font-medium sm:mb-5 mb-3 sm:mt-8 mt-3"
                style={{ lineHeight: "32px" }}
              >
                At Ogwugo, we value your privacy and are committed to protecting
                your personal information. This Privacy Policy explains how we
                collect, use, disclose, and safeguard your information when you
                use our website, mobile applications, and services (collectively,
                the “Services”).
              </h2>
            </div>
          </div>
        </Container>
      </div>

      <Container>
        <div data-test="storePrivacy-page">
          <div className=" hidden bg-white px-4 sm:px-14 py-4 text-center sm:text-left w-full sm:max-w-[1200px] mx-auto mb-1 rounded-sm  mt-10">
            <p className="  text-lg text-gray-800">
              Learn about how we manage your data
            </p>
          </div>

          <div className=" justify-center items-center mx-auto pb-10">
            <div className="bg-white dark:bg-[#010101] rounded-sm border border-gray-200 dark:border-none px-4 sm:px-4 sm:max-w-[1200px] mx-auto sm:rounded-sm w-full pb-16 sm:pb-0">
              <div className="py-1 mb-6 my-4 sm:px-4 sm:mt-10">
                {/* <h3 className="text-primary text-base font-bold my-6 sm:text-xl ">
                  Ogwugo Privacy Policy
                </h3> */}
                <p className="text-sm sm:text-lg sm:text-gray-500 dark:text-[#BCBCBC]">
                  By using Ogwugo, you agree to the terms of this Privacy
                  Policy.
                </p>
                <div className="sm:border-b dark:border-none"></div>
                <h3 className="text-base my-6 font-bold sm:text-xl">
                  1. Who We Are
                </h3>
                <p className="text-sm sm:text-lg sm:text-gray-500 dark:text-[#BCBCBC] sm:mt-8 mb-4">
                  Ogwugo is an e-commerce and logistics platform that connects
                  users for buying, selling, and delivery services.
                </p>
                <p className="text-sm sm:text-lg sm:text-gray-500 dark:text-[#BCBCBC] font-semibold mb-2">
                  Business Address:
                </p>
                <p className="text-sm sm:text-lg sm:text-gray-500 dark:text-[#BCBCBC] mb-6">
                  Bethel Plaza, 36 Garden Avenue, Enugu, Enugu State, Nigeria
                </p>
                <div className="sm:border-b dark:border-none"></div>
                <h3 className="text-base my-6 font-bold sm:text-xl">
                  2. Information We Collect
                </h3>
                <div className="sm:border-b dark:border-none"></div>
                <div className="text-sm mb-3 sm:text-lg sm:text-gray-500 dark:text-[#BCBCBC] sm:mt-8">
                  <p className="mb-4">
                    We collect only the information necessary to provide our
                    services effectively.
                  </p>
                  <p className="font-semibold mb-2">2.1 Personal Information</p>
                  <ul className="list-disc pl-6 mb-4">
                    <li className="py-1">Full name</li>
                    <li className="py-1">Email address</li>
                    <li className="py-1">Phone number</li>
                    <li className="py-1">Residential or delivery address</li>
                    <li className="py-1">
                      Means of Identification (where required)
                    </li>
                  </ul>
                  <p className="font-semibold mb-2">
                    2.2 Account & Transaction Information
                  </p>
                  <ul className="list-disc pl-6 mb-4">
                    <li className="py-1">
                      Payment details (processed securely via third-party
                      providers)
                    </li>
                    <li className="py-1">Billing and delivery details</li>
                    <li className="py-1">
                      Order history and transaction records
                    </li>
                  </ul>
                  <p className="font-semibold mb-2">
                    2.3 Usage & Technical Data
                  </p>
                  <ul className="list-disc pl-6 mb-4">
                    <li className="py-1">IP address</li>
                    <li className="py-1">Device and browser type</li>
                    <li className="py-1">
                      Pages visited and actions taken on the platform
                    </li>
                    <li className="py-1">Location data (if enabled)</li>
                  </ul>
                  <p className="font-semibold mb-2">
                    2.4 Voluntary Information
                  </p>
                  <p className="mb-4">
                    Any information you choose to publish (e.g., reviews,
                    listings) becomes publicly accessible.
                  </p>
                </div>
                <h3 className="text-base my-6 font-bold sm:text-xl">
                  3. How We Use Your Information
                </h3>
                <div className="sm:border-b dark:border-none"></div>
                <p className="text-sm mb-3 sm:text-lg sm:text-gray-500 dark:text-[#BCBCBC] sm:mt-8">
                  We use your information to:
                </p>
                <ul className="list-disc pl-6 mb-4 text-sm sm:text-lg sm:text-gray-500 dark:text-[#BCBCBC]">
                  <li className="py-1">Verify your identity and eligibility</li>
                  <li className="py-1">Create and manage your account</li>
                  <li className="py-1">
                    Process orders, payments, and deliveries
                  </li>
                  <li className="py-1">
                    Facilitate communication between users
                  </li>
                  <li className="py-1">
                    Improve our platform, services, and user experience
                  </li>
                  <li className="py-1">
                    Send service updates, notifications, and support messages
                  </li>
                  <li className="py-1">Conduct analytics and research</li>
                  <li className="py-1">
                    Provide marketing communications (only with your consent)
                  </li>
                  <li className="py-1">
                    Comply with legal and regulatory obligations
                  </li>
                </ul>
                <h3 className="text-base my-6 font-bold sm:text-xl">
                  4. Legal Basis for Processing (Nigeria NDPA 2023)
                </h3>
                <div className="sm:border-b dark:border-none"></div>
                <p className="text-sm mb-3 sm:text-lg sm:text-gray-500 dark:text-[#BCBCBC] sm:mt-8">
                  We process your data based on:
                </p>
                <ul className="list-disc pl-6 mb-4 text-sm sm:text-lg sm:text-gray-500 dark:text-[#BCBCBC]">
                  <li className="py-1">Your consent</li>
                  <li className="py-1">
                    Performance of a contract (e.g., deliveries, transactions)
                  </li>
                  <li className="py-1">Legal obligations</li>
                  <li className="py-1">
                    Legitimate business interests (e.g., improving services,
                    fraud prevention)
                  </li>
                </ul>
                <h3 className="text-base my-6 font-bold sm:text-xl">
                  5. How We Share Your Information
                </h3>
                <div className="sm:border-b dark:border-none"></div>
                <div className="text-sm mb-3 sm:text-lg sm:text-gray-500 dark:text-[#BCBCBC] sm:mt-8">
                  <p className="mb-4">We may share your information with:</p>
                  <p className="font-semibold mb-2">5.1 Service Providers</p>
                  <p className="mb-2">
                    Trusted partners who help us operate our services,
                    including:
                  </p>
                  <ul className="list-disc pl-6 mb-4">
                    <li className="py-1">Payment processors</li>
                    <li className="py-1">Logistics and delivery partners</li>
                    <li className="py-1">IT and cloud service providers</li>
                  </ul>
                  <p className="font-semibold mb-2">5.2 Affiliates</p>
                  <p className="mb-4">
                    Other Ogwugo-related entities for operational and service
                    improvement purposes.
                  </p>
                  <p className="font-semibold mb-2">5.3 Legal Authorities</p>
                  <p className="mb-4">
                    Where required by law, regulation, or legal process.
                  </p>
                  <p className="font-semibold mb-2">5.4 Business Transfers</p>
                  <p className="mb-4">
                    In the event of a merger, acquisition, or restructuring. We
                    do not sell your personal data.
                  </p>
                </div>
                <h3 className="text-base my-6 font-bold sm:text-xl">
                  6. Cookies & Tracking Technologies
                </h3>
                <div className="sm:border-b dark:border-none"></div>
                <p className="text-sm mb-3 sm:text-lg sm:text-gray-500 dark:text-[#BCBCBC] sm:mt-8">
                  We use cookies to:
                </p>
                <ul className="list-disc pl-6 mb-4 text-sm sm:text-lg sm:text-gray-500 dark:text-[#BCBCBC]">
                  <li className="py-1">Recognize returning users</li>
                  <li className="py-1">Store preferences</li>
                  <li className="py-1">
                    Improve performance and user experience
                  </li>
                  <li className="py-1">Analyze traffic and usage patterns</li>
                </ul>
                <p className="text-sm sm:text-lg sm:text-gray-500 dark:text-[#BCBCBC] mb-4">
                  You can disable cookies in your browser settings, but some
                  features may not function properly.
                </p>
                <h3 className="text-base my-6 font-bold sm:text-xl">
                  7. Data Security
                </h3>
                <div className="sm:border-b dark:border-none"></div>
                <p className="text-sm mb-3 sm:text-lg sm:text-gray-500 dark:text-[#BCBCBC] sm:mt-8">
                  We implement appropriate technical and organizational measures
                  to protect your data, including:
                </p>
                <ul className="list-disc pl-6 mb-4 text-sm sm:text-lg sm:text-gray-500 dark:text-[#BCBCBC]">
                  <li className="py-1">Secure Socket Layer (SSL) encryption</li>
                  <li className="py-1">Restricted access to personal data</li>
                  <li className="py-1">
                    Regular system monitoring and vulnerability scanning
                  </li>
                </ul>
                <h3 className="text-base my-6 font-bold sm:text-xl">
                  8. Data Retention
                </h3>
                <div className="sm:border-b dark:border-none"></div>
                <p className="text-sm mb-3 sm:text-lg sm:text-gray-500 dark:text-[#BCBCBC] sm:mt-8">
                  We retain your information only as long as necessary to:
                </p>
                <ul className="list-disc pl-6 mb-4 text-sm sm:text-lg sm:text-gray-500 dark:text-[#BCBCBC]">
                  <li className="py-1">Provide our services</li>
                  <li className="py-1">
                    Meet legal and regulatory requirements
                  </li>
                  <li className="py-1">
                    Resolve disputes and enforce agreements
                  </li>
                </ul>
                <h3 className="text-base my-6 font-bold sm:text-xl">
                  9. Your Rights (Under Nigerian Law)
                </h3>
                <div className="sm:border-b dark:border-none"></div>
                <p className="text-sm mb-3 sm:text-lg sm:text-gray-500 dark:text-[#BCBCBC] sm:mt-8">
                  You have the right to:
                </p>
                <ul className="list-disc pl-6 mb-4 text-sm sm:text-lg sm:text-gray-500 dark:text-[#BCBCBC]">
                  <li className="py-1">Access your personal data</li>
                  <li className="py-1">
                    Request correction of inaccurate data
                  </li>
                  <li className="py-1">Request the deletion of your data</li>
                  <li className="py-1">Withdraw consent at any time</li>
                  <li className="py-1">Object to certain data processing</li>
                  <li className="py-1">Request data portability</li>
                </ul>
                <p className="text-sm sm:text-lg sm:text-gray-500 dark:text-[#BCBCBC] mb-4">
                  To exercise your rights, contact us at: hello@ogwugo.com
                </p>
                <h3 className="text-base my-6 font-bold sm:text-xl">
                  10. Third-Party Links
                </h3>
                <div className="sm:border-b dark:border-none"></div>
                <p className="text-sm mb-6 sm:text-lg sm:text-gray-500 dark:text-[#BCBCBC] sm:mt-8">
                  Our platform may contain links to third-party websites. We are
                  not responsible for their privacy practices. Please review
                  their policies before submitting your data.
                </p>
                <h3 className="text-base my-6 font-bold sm:text-xl">
                  11. Children’s Privacy
                </h3>
                <div className="sm:border-b dark:border-none"></div>
                <p className="text-sm mb-6 sm:text-lg sm:text-gray-500 dark:text-[#BCBCBC] sm:mt-8">
                  Ogwugo services are not intended for individuals under 18. We
                  do not knowingly collect data from minors.
                </p>
                <h3 className="text-base my-6 font-bold sm:text-xl">
                  12. International Data Transfers
                </h3>
                <div className="sm:border-b dark:border-none"></div>
                <p className="text-sm mb-6 sm:text-lg sm:text-gray-500 dark:text-[#BCBCBC] sm:mt-8">
                  Your information may be transferred and processed outside
                  Nigeria where necessary. We ensure appropriate safeguards are
                  in place.
                </p>
                <h3 className="text-base my-6 font-bold sm:text-xl">
                  13. Updates to This Policy
                </h3>
                <div className="sm:border-b dark:border-none"></div>
                <p className="text-sm mb-6 sm:text-lg sm:text-gray-500 dark:text-[#BCBCBC] sm:mt-8">
                  We may update this Privacy Policy from time to time. Changes
                  will be posted on our platform and become effective
                  immediately upon posting.
                </p>
                <h3 className="text-base my-6 font-bold sm:text-xl">
                  14. Contact Us
                </h3>
                <div className="sm:border-b dark:border-none"></div>
                <p className="text-sm mb-2 sm:text-lg sm:text-gray-500 dark:text-[#BCBCBC] sm:mt-8">
                  For questions, complaints, or data requests:
                </p>
                <p className="text-sm mb-2 sm:text-lg sm:text-gray-500 dark:text-[#BCBCBC] font-semibold">
                  Legal Department – Ogwugo
                </p>
                <p className="text-sm mb-6 sm:text-lg sm:text-gray-500 dark:text-[#BCBCBC]">
                  Bethel Plaza, 36 Garden Avenue, Enugu, Enugu State, Nigeria
                  <br />
                  Email: shop.ogwugo@gmail.com
                </p>
                <h3 className="text-base my-6 font-bold sm:text-xl">
                  15. Security Tips for Users
                </h3>
                <div className="sm:border-b dark:border-none"></div>
                <p className="text-sm mb-3 sm:text-lg sm:text-gray-500 dark:text-[#BCBCBC] sm:mt-8">
                  To protect yourself online:
                </p>
                <ul className="list-disc pl-6 mb-4 text-sm sm:text-lg sm:text-gray-500 dark:text-[#BCBCBC]">
                  <li className="py-1">
                    Only use secure connections (https://)
                  </li>
                  <li className="py-1">Do not share your password</li>
                  <li className="py-1">
                    Avoid suspicious links and phishing sites
                  </li>
                  <li className="py-1">Always verify transactions</li>
                  <li className="py-1">Keep records of your purchases</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
}
